module.exports = __webpack_public_path__ + "static/media/Huda2.93ee533c.jpg";